document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".features-swiper").forEach(function (sliderEl) {
    const titles = Array.from(
      sliderEl.querySelectorAll(".swiper-slide")
    ).map(slide => slide.dataset.slideTitle || "");

    const paginationEl = sliderEl.querySelector(".features-pagination");

    const swiper = new MinimogLibs.Swiper(sliderEl, {
      loop: true,
      speed: 600,
      spaceBetween: 30,
      slidesPerView: 1,

      pagination: {
        el: paginationEl,
        type: "custom",
        clickable: true,
        renderCustom: function (swiper, current, total) {
          return titles
            .map((title, index) => {
              const active = index === current - 1 ? "active" : "";
              return `
                <button
                  class="feature-tab ${active}"
                  data-index="${index}"
                  type="button"
                >
                  ${title}
                </button>
              `;
            })
            .join("");
        },
      },

      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
      },
    });

    // Handle clicks manually
    paginationEl.addEventListener("click", function (e) {
      const btn = e.target.closest(".feature-tab");
      if (!btn) return;

      const index = Number(btn.dataset.index);
      swiper.slideToLoop(index);
    });
  });
});
